// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SearchResultSummaryContextProperties = {
  actual_number_of_results?: number;
  last_search_status?: string;
  max_updated_at?: number;
  number_of_results_updating?: number;
  sorting: string;
  currency?: string;
  min_price_in_cents?: number;
  number_of_backend_filtered_results?: number;
  max_departure_hour?: number;
  number_of_selling_out_results?: number;
  number_of_results: number;
  last_updated_at?: number;
  min_departure_hour?: number;
  travel_mode: string;
  number_of_filtered_results?: number;
  min_price_euro_cents?: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/search_result_summary_context/jsonschema/2-0-0';
export const searchResultSummaryContextName = 'search_result_summary_context';
export class SearchResultSummaryContext extends BaseTrackingContext<SearchResultSummaryContextProperties> {
  constructor(properties: SearchResultSummaryContextProperties) {
    super(searchResultSummaryContextName, schema, properties);
  }
}
